import { Component, Input } from '@angular/core';
import { ItemDataService } from '../../services/item-data.service';
import { DivCard } from '../../models/item-data-models';
import { ValueComponent } from '../value/value.component';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-divcard-viewer',
  templateUrl: './divcard-viewer.component.html',
  styleUrl: './divcard-viewer.component.scss',
  imports: [ValueComponent],
})
export class DivCardViewerComponent extends BaseComponent {
  constructor(private itemDataService: ItemDataService) {
    super();
  }

  @Input({ required: true }) name!: string;
  @Input() showDropInfo?: boolean;
  @Input() hideTooltip?: boolean;
  @Input() pinned?: boolean;

  divinationCard?: DivCard;

  showTooltip = true;

  onMouseEnter() {
    this.divinationCard = this.itemDataService.getDivinationCard(this.name);
    this.showTooltip = true;
  }

  onMouseLeave() {
    this.showTooltip = false;
  }

  getBackgroundImage(): string {
    if (!this.divinationCard) return '';
    // Use multiple backgrounds: actual image first, then placeholder
    return `url(https://web.poecdn.com/image/divination-card/${this.divinationCard.artFileName}.png), url(/img/divination-card-placeholder.webp)`;
  }
}
